import { TableGridItem, TableGridPaginationState } from "@/models/table-grid-interface";
import { parseVMListToTableGridItems } from "./properties-mapping-service";

import { useAccountApi, useAccountNetworkApi, FilterItem } from '@ui-api3-sdk/api/api3';
import { usePropertiesStore } from '../pinia/usePropertiesStore';

import { nodeIdFromItem } from "@/models/tree-interface";
import { useAccountStore } from "@/pinia/useAccountStore";
import {useToast} from "@/composables";

export const DOWNLINE_MAX_LIMIT = 250;

export type DownlineServiceParams = {
  treeId: number,

  accountId: number,
  offset?: number,
  positionId?: number,

  properties: string[],

  periodId?: number,
  filter?: FilterItem[],
  pagination?: TableGridPaginationState,
  depth?: number,

  doNotUpdatePropertyTypes?: boolean,
  includeTree?: number,
  showInactive?: 'none' | 'all_inactive' | 'only_disabled',

  disableCountTotal?: boolean,
  disableSorting?: boolean,

};
export type DownlineExportParams = {
    id: number,
    exportDownlineReq: {
        delimiter: string,
        exportHeaders: { title: string, path: string }[],
        properties: string[],
        showInactiveAccounts: boolean,
        rawValues?: any, // API types say 'object' but it should be boolean
    },
    treeId?: number,
    orderBy?: Record<string, 'ASC' | 'DESC'>,
    filter?: FilterItem[],
};

export async function fetchDownline(dp: DownlineServiceParams, maxNodesPerRequest?: number) {

  const requestPlanProperties = dp.properties.filter((p) => p.startsWith('m.')).map((p) => p.split('.')[1]);

  const maxNodes = maxNodesPerRequest || DOWNLINE_MAX_LIMIT;
  let hitRequestLimit = false;

  const rp = {
    id: dp.accountId,
    limit: dp.pagination?.limit || maxNodes,
    page: dp.pagination?.page ? dp.pagination?.page - 1 : 0,
    periodId: dp.periodId,
    treeId: dp.treeId,
    properties: requestPlanProperties,
    depth: dp.depth,
    offset: dp.offset,
    positionId: dp.positionId,
    includeTree: dp.includeTree,
    showInactiveAccounts: false,
    showDisabledAccounts: false,
   };

  if (dp.showInactive === 'all_inactive') {
    rp.showInactiveAccounts = true;
    rp.showDisabledAccounts = true;
  } else if (dp.showInactive === 'only_disabled') {
    rp.showDisabledAccounts = true;
  }

  const countTotal = !dp.disableCountTotal ? undefined : false;
  const disableSorting = dp.disableSorting ? true : undefined;

  if (useAccountStore().heavyDownlineMode) {
    // Sasha said that now jeunese should work without those limitations
    // countTotal = false;
    // disableSorting = true;
  }

  const res = await useAccountNetworkApi().v2DownlineControllerGetDownline(rp, {
    params: {
      countTotal,
      disableSorting,
      filter: dp.filter,
      orderBy: dp?.pagination?.orderBy,
    },
  });

  if (!dp.doNotUpdatePropertyTypes) {
    usePropertiesStore().updatePlanProperties(res.data.map.planProperties);
    usePropertiesStore().updateProfileFields(res.data.map.profileFields);
  }

  const totalItems = res.data.payload.total;
  const downlinePositionList = res.data.payload.list;

  const tableItems = parseVMListToTableGridItems(
    [],
    downlinePositionList,
  );

  if (! totalItems && tableItems.length) {
    // means we in heavyDownline mode.
    hitRequestLimit = ! ( tableItems.length < maxNodes );
  } else {
    hitRequestLimit = totalItems > (rp.page * rp.limit) + tableItems.length;
  }

  return {
    totalItems,
    tableItems,
    requestParams: rp,

    maxNodes,
    hitRequestLimit,
    lastNode: tableItems.length > 0 ? tableItems[tableItems.length - 1] : undefined,
    lastParams: {
      ... dp,
      pagination: {
        ... dp.pagination,
        page: dp.pagination?.page ? dp.pagination.page : 1,
        limit: rp.limit,
      },
    },

  };

}
export async function exportDownline(dp: DownlineExportParams, successMsg: string, errorMsg: string, properties: string[]) {
  let params = dp
  function mapToExportKey(prop: string): string | undefined {
    const [, prefix, suffix] = prop.match(/^([^.]+)\.(.+)$/) || [];

    switch (prefix) {
      case "m":
        return `properties.${suffix}`;
      case "p": {
        // Account-level properties
        const accountKeys = ['no_sign_up', 'title', 'invite_code', 'account_status_id', 'external_id'];
        // User-level properties
        const userKeys = ['language_id', 'email_verification_status', 'last_email_verification'];
        // Special cases that need custom mapping
        if (suffix === 'created_at') return 'account.created_at';
        if (suffix === 'last_login') return 'account.user.last_login';
        if (suffix === 'privacy' || suffix === 'online_office_admin') {
          // These fields don't exist in the API headers, will be filtered out later
          return undefined;
        }

        if (accountKeys.includes(suffix)) return `account.${suffix}`;
        if (userKeys.includes(suffix)) return `account.user.${suffix}`;
        return `account.profile.${suffix}`;
      }
      case "s":
        if (suffix === "id") return "account.id";
        return `account.${suffix}`;
      case "parent":
        return `parentPosition.account.${suffix}`;
      case "parent-profile": {
        // Special case for parent-profile.title - it maps to parentPosition.account.title
        if (suffix === "title") return `parentPosition.account.title`;
        return `parentPosition.account.profile.${suffix}`;
      }
      default:
        return undefined;
    }
  }
    try {
        const rp = {
            id:dp.id,
            exportDownlineReq:dp.exportDownlineReq
        };
      const normalizedExportKeys = properties
        .map(p => mapToExportKey(p))

       console.log('normalizedExportKeys', normalizedExportKeys)
       console.log('properties', properties)
      //  const getPfValue =  usePropertiesStore().getPfValue();
      //  const getPPValue = usePropertiesStore().getPpValue();
      //   console.log('getPfValue', getPfValue)
      //   console.log('getPPValue', getPPValue)
      const allHeaders = await useAccountNetworkApi().getExportHeaders({ id: dp.id! });
    console.log('allHeaders', allHeaders)
      const exportHeaders = normalizedExportKeys
        .map(key => {
          const header = allHeaders.data.payload.find(h => h.path === key);
          if (!header) return null;
          return {
            title: header.name,
            path: header.path
          };
        })
        .filter((header): header is { title: string; path: string } => header !== null)
        console.log('exportHeaders', exportHeaders)
        params.exportDownlineReq.exportHeaders = (exportHeaders as { title: string, path: string}[])
        await useAccountNetworkApi().startExport(params, {
            params: {
                filter: dp.filter,
                orderBy: dp.orderBy,
                treeId: dp.treeId,
            },
        });
        useToast().ok(successMsg);
        return {
            requestParams: rp,
        };
    }
    catch (e) {
      console.error(e)
        useToast().error(errorMsg);
    }



}

/*
export async function fetchDownlineAll(
  dp: DownlineServiceParams, batchSize?: number, maxNodesPerRequest?: number) {

  console.log('downlineAll batch=', batchSize, 'maxNodes=', maxNodesPerRequest, 'dp=', dp);

  const result: TableGridItem[] = [];

  const limit = batchSize || useAccountStore().downlineMaxLimit;

  const params = { ...dp };

  if (!params.pagination)
      params.pagination = { limit, page: 1, orderBy: { 's.id': 'ASC' } };

  let knownTotal = 0;
  let batchCount = 0;
  let hitRequestLimit = false;
  let needStop = false;

  const maxNodes = maxNodesPerRequest || DEFAULT_DOWNLINE_BATCH_TOTAL_MAX_NODES;

  while (!needStop) {
    const { tableItems, totalItems, requestParams } = await fetchDownline(params);
    result.push(...tableItems);

    knownTotal = totalItems;
    batchCount++;

    const fetchedItems = tableItems.length;
    const wasLimit = requestParams.limit;
    const noMoreItems = fetchedItems < wasLimit;

    if (result.length > maxNodes) {
      hitRequestLimit = true;
    }

    if (noMoreItems || hitRequestLimit || result.length === maxNodes) {
      needStop = true;
    } else {
      params.pagination.page++;
      params.doNotUpdatePropertyTypes = true;
    }
  }

  result.sort((a, b) => {
    const aLevel = Number(a['vmdl.level']?.raw || 0);
    const bLevel = Number(b['vmdl.level']?.raw || 0);
    return aLevel - bLevel;
  });

  if (result.length > maxNodes) {
    const splicedNodes = result.splice(maxNodes);
    console.log('splicedNodes', splicedNodes);
  }

  return {
    totalItems: knownTotal,
    tableItems: result,

    hitRequestLimit,
    batchCount,
    batchSize: limit,
    maxNodes,

    lastNode: result.length > 0 ? result[result.length - 1] : undefined,
    lastParams: params,
  };
}
*/

export function removeDuplicateNodes(arr: TableGridItem[]) {
  const result: TableGridItem[] = [];
  const map = new Map();
  for (const item of arr) {
    const id = nodeIdFromItem(item);
    if (!map.has(id)) {
      map.set(id, true);
      result.push(item);
    }
  }
  return result;
}
